module.exports = __webpack_public_path__ + "static/media/T+T_GraceBeck_-7.71539c28.JPG";